module.exports = __webpack_public_path__ + "img/btn_link_3.a34df26f.png";